import { Outlet } from 'react-router-dom';
import { PanelGroup } from '@cbridge-tools/resizable-panels';
import { SidePanelVariant, SidePanel, MainPanel, usePersistedPanelLayout, panelLayoutSettingKey } from '@cbridge-modules/layout';
import { UserSettingsPage } from '@cbridge-packages/user-settings';
import { SettingsNavigation } from '../../_navigation/SettingsNavigation';

export const AlertsLayout = () => {
  const layoutProps = usePersistedPanelLayout(panelLayoutSettingKey(UserSettingsPage.ConfigSettingsAlerts, 'page'));

  return (
    <PanelGroup direction={'horizontal'} {...layoutProps}>
      <SidePanel variant={SidePanelVariant.Left}>
        <SettingsNavigation />
      </SidePanel>
      <MainPanel>
        <Outlet />
      </MainPanel>
    </PanelGroup>
  );
};
